//import Web3 from 'web3';

const metamaskInstalled = false; // typeof window.web3 !== 'undefined';
/*
export const web3 = metamaskInstalled ?
      new Web3(window.web3.currentProvider) :
      new Web3(new Web3.providers.HttpProvider('https://ropsten.infura.io/v3/2f3dce2af1044e88b4851c3d73c3d00c'));
export const web3WSS = 
    new Web3(new Web3.providers.WebsocketProvider('wss://ropsten.infura.io/ws/v3/2f3dce2af1044e88b4851c3d73c3d00c'));
    */


class Contract {
    constructor() {
        this.methods = {};
        this.options = {
            address: ''
        };
    }
}

export const web3 = {
    eth: {
        Contract: Contract,
        net: {
            isListening: () => true
        }
    },
    utils: {
        asciiToHex: () => 'aa',
        padLeft: () => '',
        padRight: () => '',
    }
};

export const web3WSS = web3;
